<template>
  <div>
    <CCardBody>
      <router-link :to="{name: 'orders'}">
        <button class="btn btn-info" >Go back</button>
      </router-link>
      <template v-if="factory_product">
<!--        <cRow class="mt-3">-->
<!--          <cCol class="col-3">-->
<!--            <strong>Company:</strong> {{order.company.company_name}}-->
<!--          </cCol>-->
<!--          <cCol class="col-3">-->
<!--            <strong>Customer:</strong> {{order.customer.customer_name}}-->
<!--          </cCol>-->
<!--          <cCol class="col-3">-->
<!--            <strong>Email:</strong> {{order.customer.email}}-->
<!--          </cCol>-->
<!--          <cCol class="col-3">-->
<!--            <strong>Product:</strong> {{order.product.product_name}}-->
<!--          </cCol>-->
<!--          <cCol class="col-3">-->
<!--            <strong>Production File:</strong>-->
<!--            <a :href="`${storage_url}/${order.file_url}`" target="_blank">view</a>-->
<!--          </cCol>-->
<!--        </cRow>-->
        <cRow class="mt-3">
          <cCol class="col-12">
            <h4>Roster Detail</h4>
          </cCol>

          <cCol class="col-6 mt-5">
            <template v-if="factory_product && factory_product.hasOwnProperty('roster_detail') && factory_product.roster_detail.length > 0">
              <b-table
                  :items="factory_product.roster_detail"
                  :fields="roster_headers"
                  hover
                  sorter
              >
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No roster exists
                </cCol>
              </cRow>
            </template>
          </cCol>
<!--          <cCol class="col-6 mt-5">-->
<!--            <cRow>-->
<!--              <template v-if="order.cutting_file_objects.length">-->
<!--                <cCol class="col-4" v-for="(cutting_file_object, cfoIdx) in order.cutting_file_objects" :key="cfoIdx">-->
<!--                  <b-card :title="cutting_file_object.size_name">-->
<!--                    <div style="width: 150px; height: 150px; cursor: pointer" v-html="cutting_file_object.final_cutting_file"-->
<!--                         @click="downloadCuttingSize(cutting_file_object, order.order_production_file_obj.original_attributes)"></div>-->
<!--                  </b-card>-->
<!--                </cCol>-->
<!--              </template>-->
<!--              <template v-else="">-->
<!--                <cCol class="col-12">-->
<!--                  No data exist-->
<!--                </cCol>-->
<!--              </template>-->
<!--            </cRow>-->
<!--          </cCol>-->
        </cRow>
        <cRow class="mt-3">
          <cCol class="col-6 mt-5">
            <cCol class="col-12">
              <h4>Custom Names</h4>
            </cCol>
            <template v-if="factory_product && factory_product.hasOwnProperty('custom_names') &&  factory_product.custom_names.length > 0">
              <b-table
                  :items="factory_product.custom_names"
                  :fields="custom_text_headers"
                  hover
                  sorter
              >
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No Custom Names Exists
                </cCol>
              </cRow>
            </template>
          </cCol>
          <cCol class="col-6 mt-5">
            <cCol class="col-12">
              <h4>Custom Numbers</h4>
            </cCol>
            <template v-if="factory_product && factory_product.hasOwnProperty('custom_numbers') && factory_product.custom_numbers.length > 0">
              <b-table
                  :items="factory_product.custom_numbers"
                  :fields="custom_text_headers"
                  hover
                  sorter
              >
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No Custom Numbers Exists
                </cCol>
              </cRow>
            </template>
          </cCol>
        </cRow>
        <cRow class="mt-3">
          <cCol class="col-6 mt-5">
            <cCol class="col-12">
              <h4>Custom Logos</h4>
            </cCol>
            <template v-if="factory_product && factory_product.hasOwnProperty('custom_logos') && factory_product.custom_logos.length > 0">
              <b-table
                  :items="factory_product.custom_logos"
                  :fields="custom_logos_headers"
                  hover
                  sorter
              >
                <template #cell(url)="data">
                  <img :src="`${storage_url}/${data.item.url}`" alt="" width="100" >
                </template>
                <template #cell(size)="data">
                  <div>{{data.item.width}} X {{data.item.height}}</div>
                </template>
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No Custom Logos Exists
                </cCol>
              </cRow>
            </template>
          </cCol>
          <cCol class="col-6 mt-5">

          </cCol>
        </cRow>
        <cRow class="mt-3">
          <cCol class="col-6 mt-5">
            <cCol class="col-12">
              <h4>SVG Groups</h4>
            </cCol>
            <template v-if="factory_product && factory_product.hasOwnProperty('svg_groups') && factory_product.svg_groups.length > 0">
              <b-table
                  :items="factory_product.svg_groups"
                  :fields="svg_group_headers"
                  hover
                  sorter
              >
                <template #cell(url)="data">
                  <img :src="`${storage_url}/${data.item.url}`" alt="" width="100" >
                </template>
                <template #cell(size)="data">
                  <div>{{data.item.width}} X {{data.item.height}}</div>
                </template>
              </b-table>
            </template>
            <template v-else="">
              <cRow>
                <cCol class="col-12">
                  No Custom Logos Exists
                </cCol>
              </cRow>
            </template>
          </cCol>
          <cCol class="col-6 mt-5">

          </cCol>
        </cRow>
      </template>
    </CCardBody>
  </div>
</template>

<script>

import {http} from "@/config/httpCommon";
import $ from "jquery";
import {forEach, intersection, map, filter} from "lodash";
import {urlToBase64} from "../../helpers";

export default {
  name: "order-view",
  data () {
    return {
      order: null,
      order_detail: null,
      order_item_id: this.$route.params.order_item_id,
      factory_product_id: this.$route.params.factory_product_id,
      storage_url: process.env.VUE_APP_FILE_URL,
      factory_product:{},
      roster_headers: [
        {key: 'size', label: 'Size'}, {key: 'code', label: 'Code'}, {key: 'number', label: 'Number'}, {key: 'text', label: 'Text'}
      ],
      custom_text_headers: [
        {key: 'text', label: 'Text'}, {key: 'side', label: 'Side'}, {key: 'fillColor', label: 'Color'}, {key: 'fontFamily', label: 'Font Famliy'}
      ],
      custom_logos_headers: [
        {key: 'url', label: 'Logo'}, {key: 'side', label: 'Side'}, {key: 'size', label: 'Size'}
      ],
      svg_group_headers: [
        {key: 'id', label: 'Name'}, {key: 'name', label: 'Name'}, {key: 'color', label: 'color'}
      ],
      production_cutting_file: {
        file_info: null,
        file_content: null
      }
    }
  },
  created() {
    let self = this;
    self.getOrderDetail();
  },
  methods: {
    async getOrderDetail() {
      let self = this;
      let url = `customer-orders/${self.order_item_id}/${self.factory_product_id}`
      this.$store.commit('set', ['showLoader', true]);
      http.get(url).then(async successResponse => {
        console.log(successResponse);
        let factory_product = successResponse.data.result;
        factory_product.custom_names = filter(factory_product.custom_texts, ["type", "name"])
        factory_product.custom_numbers = filter(factory_product.custom_texts, ["type", "number"])
        this.factory_product = factory_product;
        // let response_data = successResponse.data;
        // let order_data = response_data.result.order
        // let order_detail = order_data.order_detail;
        // order_detail.custom_names = filter(order_detail.custom_texts, ["type", "name"])
        // order_detail.custom_numbers = filter(order_detail.custom_texts, ["type", "number"])
        // delete order_detail.custom_texts
        // self.order_detail = order_detail;
        // self.order = order_data;
        // await self.getRosterFiles(order_data)
        this.$store.commit('set', ['showLoader', false]);
      }, errorResponse => {
        this.$store.commit('set', ['showLoader', false]);
        console.log("error getting order detail", errorResponse)
      });
    },
    async getProductionCuttingFile() {
      let self = this;
      let production_cutting_file_url = `${self.storage_url}/${self.order.production_cutting_file_url}`
      let production_cutting_file_content = await  self.fetchUrlContent(production_cutting_file_url);
      let custom_logos_texts_string = "";
      for(let custom_text_svg of self.order_detail.custom_text_svgs) {
        custom_logos_texts_string += custom_text_svg;
      }
      for(let custom_logo_svg of self.order_detail.custom_logo_svgs) {
        let logo_url = $(custom_logo_svg).find("img:eq(0)").attr("xlink:href")
        if( logo_url) {
          try {
            let base64_logo = await urlToBase64(logo_url);
            custom_logo_svg = custom_logo_svg.replace(logo_url, base64_logo)
          } catch (errorResponse) {
            console.log(errorResponse)
          }
        }
        custom_logos_texts_string += custom_logo_svg;
      }

      if(custom_logos_texts_string) {
        production_cutting_file_content = production_cutting_file_content.substring(0, production_cutting_file_content.lastIndexOf("</g>"));
        production_cutting_file_content += `${custom_logos_texts_string}\n</g>\n</svg>`
      }
      self.production_cutting_file.file_content = production_cutting_file_content;
      let production_cutting_file_document = await self.getDocFromString(production_cutting_file_content);
      self.production_cutting_file.file_info =  {
        width: $(production_cutting_file_document).find("svg").eq(0).attr("width"),
        height: $(production_cutting_file_document).find("svg").eq(0).attr("height")
      }
      $(production_cutting_file_document).find("svg").eq(0).attr({"width": "150px", "height": "150px"})
      self.production_cutting_file.file_content = new XMLSerializer().serializeToString(production_cutting_file_document);
    },
    async getDocFromString(doc_string, type="image/svg+xml") {
      let parser = new DOMParser();
      return  parser.parseFromString(doc_string, type);
    },
    async getCuttingFilesObjects(order) {
      let self = this;
      let cutting_file_obj = order.product_style.cutting_file;
      let order_roster_sizes_objs = self.order_detail.roster_detail;
      let cutting_file_sizes = cutting_file_obj ? cutting_file_obj.file_sizes : [];
      let roster_sizes = map(order_roster_sizes_objs, "code");
      cutting_file_sizes = intersection(cutting_file_sizes, roster_sizes)
      let cutting_file_id = cutting_file_obj ? cutting_file_obj.id : null;
      let cutting_file_objects = [];
      let storage_url = self.storage_url
      forEach(cutting_file_sizes, (file_size) => {
        cutting_file_objects.push({
          file_url: `${storage_url}/factory_cuttings/${cutting_file_id}/${file_size}.svg`,
          file_content: null,
          final_cutting_file: null,
          size_name: file_size
        })
      })
      return cutting_file_objects;
    },
    async fetchUrlContent(url) {
      let fetch_content = await fetch(url);
      let url_content   = await fetch_content.text();
      return url_content;
    },
    async downloadCuttingFile() {
      let self = this;
      let anchor = document.createElement('a');
      let svg_elem = await self.getDocFromString(self.production_cutting_file.file_content);
      $(svg_elem).find("svg").eq(0).attr(self.production_cutting_file.file_info);
      let svg_elem_content = new XMLSerializer().serializeToString(svg_elem)
      anchor.setAttribute('href', 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg_elem_content));
      anchor.setAttribute('download', `Production Cutting File.svg`);
      anchor.style.display = 'none';
      document.body.appendChild(anchor);

      anchor.click();

      document.body.removeChild(anchor);
    }
  }
}
</script>

<style scoped>

</style>